import { mapGetters } from 'vuex'
import config from '@/common/config'

export default {
  data: function() {
    return {}
  },
  computed: {
    ...mapGetters({
      isDebug: 'isDebugModeActive',
      isEmbedded: 'isEmbedded',
      darkMode: 'isDarkModeActive',
    }),
    isMobileViewPort() {
      return this.$mq === 'sm' || this.$mq === 'xs'
    },
    isDev() {
      return config.get('env') === 'development'
    },
    reliefRosterUrl() {
      return config.get('reliefRosterUrl')
    },
  },
}
